module.exports = __webpack_public_path__ + "img/MemoIcon.6ae3077a.svg";